import { CHAIN_REGISTRY } from '@/config/chains'
import { CHAIN_LOGOS } from './logos'
import type { Chain } from '@/types'

interface ChainIconProps {
  chain: Chain
  size?: number
}

export function ChainIcon({ chain, size = 16 }: ChainIconProps) {
  const meta = CHAIN_REGISTRY[chain]
  const Logo = CHAIN_LOGOS[chain]

  // Use brand SVG when available, letter-circle fallback otherwise
  if (Logo) {
    return (
      <span aria-hidden="true" style={{ display: 'inline-flex', flexShrink: 0 }}>
        <Logo size={size} />
      </span>
    )
  }

  return (
    <span aria-hidden="true" style={{ display: 'inline-flex', flexShrink: 0 }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: meta.color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          overflow: 'hidden',
        }}
      >
        <span
          style={{
            color: '#fff',
            fontSize: size * 0.5,
            fontWeight: 700,
            lineHeight: 1,
          }}
        >
          {meta.letter}
        </span>
      </div>
    </span>
  )
}
